import React from 'react'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import { itemsToBringStore } from 'state/listing/itemsToBringListing'
import useFormSubmit from 'helper/Hooks/formSubmit'
import ItemsToBringForm from './ModalContent/ItemsToBringForm'

interface ItemsToBringModalProps {
  organizationId?: string
}

const ItemsToBringModal: React.FC<ItemsToBringModalProps> = ({
  organizationId,
}) => {
  const { form, handleSubmit } = useFormSubmit()
  const { addItemsToBringModal, setAddItemsToBringModal, itemsToBringData } =
    itemsToBringStore(store => ({
      addItemsToBringModal: store.addItemsToBringModal,
      setAddItemsToBringModal: store.setAddItemsToBringModal,
      itemsToBringData: store.itemsToBringData,
    }))

  return (
    <>
      <CustomModal
        openModal={addItemsToBringModal}
        closeModal={setAddItemsToBringModal}
        title={itemsToBringData ? 'Edit Item to bring' : 'Add Item to bring'}
        footer={
          <CustomModalFooter
            multibutton={false}
            btnAlignment="justify-end"
            btnText={itemsToBringData ? 'Update' : 'Create'}
            btnType="primary"
            onSubmit={handleSubmit}
          />
        }
      >
        <ItemsToBringForm form={form} organizationId={organizationId} />
      </CustomModal>
    </>
  )
}

export default ItemsToBringModal
